import React from "react";
import { Modal as AntModal, Button, message } from "antd";
import styled from "styled-components";
import { CopyOutlined } from "@ant-design/icons";
import { IconCarDelivery, IconPhoneDeli } from "../../../../assets/icons";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-content {
    border-radius: 12px;
    padding: 30px 25px;
  }

  .ant-modal-header {
    border-bottom: none;
  }

  .ant-modal-title {
    font-size: 24px;
    font-weight: 700;
    color: #1e1e1e;
    line-height: 34px;
  }

  .ant-modal-body {
    padding-top: 0;
  }

  .ant-modal-footer {
    border-top: none;
    padding: 0;
    margin-top: 24px;

    .ant-btn {
      width: 100%;
      height: 56px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
    }

    .ant-btn-primary {
      background: #1f5eff;
    }
  }
`;

const Label = styled.div`
  font-size: 14px;
  color: #868686;
  margin-bottom: 4px;
  line-height: 18px;
`;

const LabelFirst = styled.div`
  font-size: 16px;
  color: #868686;
  margin-bottom: 4px;
  line-height: 24px;
`;

const Value = styled.div`
  font-size: 16px;
  color: #1e1e1e;
  line-height: 26px;
  font-weight: 400;
`;
const ValueFirst = styled.div`
  font-size: 16px;
  color: #1e1e1e;
  line-height: 26px;
  font-weight: 400;
  padding-top: 6px;
`;

const Section = styled.div`
  margin-top: 20px;
`;

const AddressBox = styled.div`
  border-left: 2px solid #e6e6e6;
  padding-left: 12px;
  margin-top: 8px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const DeliRequestModal = ({
  open,
  handleClose,
  order,
}) => {

  const {t} = useTranslation();


  const handleCopy = (copyData) => {
    navigator.clipboard.writeText(copyData);
    message.success(t('copy_to'));
  };


  return (
    <Modal
      centered
      width={520}
      open={open}
      onCancel={handleClose}
      title="Request Delivery Detail"
      footer={
        <Button type="primary" onClick={() => handleClose()}>
          {t('ok')}
        </Button>
      }
    >
      {/* <p style={{ color: "#6b6b6b", marginBottom: 20 }}>
        Are you sure to send the delivery request for this parcel? Please fill
        the required information.
      </p> */}

      {/* Order ID */}
      <Section style={{display:"flex",alignItems:"center", gap:"10px"}}>
        <Label>{t('order_id')} :</Label>
        <Row>
          <Value>{order?.order_id}</Value>
          <CopyOutlined
            style={{ cursor: "pointer", color: "#8c8c8c" }}
            onClick={() => handleCopy(order?.order_id)}
          />
        </Row>
        
      </Section>
      <Section style={{display:"flex",alignItems:"center", gap:"10px",marginTop:"10px"}}>
      <Label>{t('delivery_id')} :</Label>
        <Row>
          <Value>{order?.delivery_request?.delivery_system_id}</Value>
          <CopyOutlined
            style={{ cursor: "pointer", color: "#8c8c8c" }}
            onClick={() => handleCopy(order?.delivery_request?.delivery_system_id)}
          />
        </Row>
    </Section>
     <Section style={{display:"flex",alignItems:"center", gap:"10px",marginTop:"10px"}}>
      <Label>{t('tracking_id')} :</Label>
        <Row>
          <Value>{order?.delivery_request?.tracking_id}</Value>
          <CopyOutlined
            style={{ cursor: "pointer", color: "#8c8c8c" }}
            onClick={() => handleCopy(order?.delivery_request?.tracking_id)}
          />
        </Row>
    </Section>
      {/* Delivery Service */}
      <Section>
        <Label>{t('deli_service')}</Label>
        <Row style={{paddingTop:"8px"}}>
          <IconCarDelivery/>
          <Value>{order?.delivery_system?.name}</Value>
          <IconPhoneDeli style={{ color: "#8c8c8c" }} />
          <Value>{order?.delivery_system?.phone}</Value>
        </Row>
      </Section>

      {/* From */}
      <Section>
        <LabelFirst>{t('from')}</LabelFirst>
        <AddressBox>
          <Label>{t('address_details')}</Label>
          <ValueFirst>{order?.delivery_request?.from_address}</ValueFirst>
        </AddressBox>
        <AddressBox>
          <Label>{t('phone')}</Label>
          <ValueFirst>{order?.delivery_request?.from_phone}</ValueFirst>
        </AddressBox>
      </Section>

      {/* To */}
      <Section>
        <LabelFirst>{t('to')}</LabelFirst>
        <AddressBox>
          <Label>{t('address_details')}</Label>
          <ValueFirst>{order?.delivery_request?.to_address}</ValueFirst>
        </AddressBox>
        <AddressBox>
          <Label>{t('phone')}</Label>
          <ValueFirst>{order?.delivery_request?.to_phone}</ValueFirst>
        </AddressBox>
      </Section>

      {/* Note */}
      <Section>
        <Label>{t('note_deli_service')}</Label>
        <AddressBox style={{paddingTop:"5px"}}>
          <Label>{t('note')}</Label>
          <ValueFirst>{order?.delivery_request?.note}</ValueFirst>
        </AddressBox>
      </Section>
    </Modal>
  );
};

export default DeliRequestModal;